export class ComponentManager {
    constructor(showLeagueInEventCard, outrightSelectionsCount, shouldShowOutrightSubheading, deviceDetect, componentManagerConstants) {
        this.showLeagueInEventCard = showLeagueInEventCard;
        this.outrightSelectionsCount = outrightSelectionsCount;
        this.shouldShowOutrightSubheading = shouldShowOutrightSubheading;
        this.deviceDetect = deviceDetect;
        this.constants = componentManagerConstants;
    }
    getSubheadingHeight() {
        return this.deviceDetect.isDesktop
            ? this.constants.heights.Subheading.desktop
                + this.constants.offsets.Subheading.desktop // 38 + 2 = 40
            : this.constants.heights.Subheading.mobile
                + this.constants.offsets.Subheading.mobile; // 48 + 1 = 49
    }
    getComponentHeight(event, markets, showOddButtons) {
        return this[`measure${event.componentType}`](event, markets, showOddButtons);
    }
    getAmericanSelectionsMaxCount(markets) {
        return markets && markets.some(m => m.selections.length > 2) ? 3 : 2;
    }
    measureAggregateCard() {
        // Desktop version same as Mobile
        return this.constants.heights.AggregateCard.desktop
            + this.constants.offsets.AggregateCard.desktop; // 73 + 4 = 77
    }
    measureEventCard(event, markets) {
        return event.cardType
            ? this[`measureEventCard${event.cardType}`](event, markets)
            : 0;
    }
    measureEventCardAmerican(event, markets) {
        const selectionsCount = this.getAmericanSelectionsMaxCount(markets);
        return this.deviceDetect.isDesktop
            ? this.setAmericanCardHeightDesktop(selectionsCount)
            : this.setAmericanCardHeightMobile(selectionsCount);
    }
    measureEventCardMultiview(event) {
        // WARNING: Make sure that you see RegularCard on Mobile, instead of MultiviewCard
        if (!this.deviceDetect.isDesktop) {
            return this.showLeagueInEventCard
                ? this.constants.heights.DefaultCard.mobile
                    + this.constants.heights.LeagueInEventCard.mobile
                    + this.constants.offsets.DefaultCard.mobile // 84 + 20 + 2 = 106
                : this.constants.heights.DefaultCard.mobile
                    + this.constants.offsets.DefaultCard.mobile; // 84 + 2 = 86
        }
        return this.showLeagueInEventCard
            ? this.constants.heights.DefaultCard.desktop
                + this.constants.heights.LeagueInEventCard.desktop
                + this.constants.offsets.DefaultCard.desktop // 60 + 20 + 2 = 82
            : this.constants.heights.DefaultCard.desktop
                + this.constants.offsets.DefaultCard.desktop; // 60 + 2 = 62
    }
    measureEventCardRegular(event) {
        if (this.deviceDetect.isDesktop) {
            return this.showLeagueInEventCard
                ? this.constants.heights.DefaultCard.desktop
                    + this.constants.heights.LeagueInEventCard.desktop
                    + this.constants.offsets.DefaultCard.desktop // 84 + 20 + 2 = 106
                : this.constants.heights.DefaultCard.desktop
                    + this.constants.offsets.DefaultCard.desktop; // 84 + 2 = 86
        }
        return this.showLeagueInEventCard
            ? this.constants.heights.DefaultCard.mobile
                + this.constants.heights.LeagueInEventCard.mobile
                + this.constants.offsets.DefaultCard.mobile // 60 + 20 + 2 = 82
            : this.constants.heights.DefaultCard.mobile
                + this.constants.offsets.DefaultCard.mobile; // 60 + 2 = 62
    }
    measureMiniEventCard(event, markets, showOddButtons) {
        return event.cardType
            ? this[`measureMiniEventCard${event.cardType}`](showOddButtons, markets)
            : 0;
    }
    measureMiniEventCardAmerican(showOddButtons, markets) {
        const selectionsCount = this.getAmericanSelectionsMaxCount(markets);
        const buttonsHeight = this.setMiniAmericanCardHeightDesktop(selectionsCount);
        return showOddButtons
            ? this.constants.heights.DefaultMiniCard.desktop
                + buttonsHeight
                + this.constants.offsets.DefaultMiniCard.desktop // 56 + 64 OR 94 + 2 = 122 OR 152
            : this.constants.heights.DefaultMiniCard.desktop
                + this.constants.offsets.DefaultMiniCard.desktop; // 56 + 2 = 58
    }
    measureMiniEventCardRegular(showOddButtons, markets) {
        return showOddButtons
            ? this.constants.heights.DefaultMiniCard.desktop
                + this.constants.heights.ButtonInMiniRegularCard.desktop
                + this.constants.offsets.ButtonContainerMiniCard.desktop
                + this.constants.offsets.DefaultMiniCard.desktop // 56 + 46 + 4 + 2 = 108
            : this.constants.heights.DefaultMiniCard.desktop
                + this.constants.offsets.DefaultMiniCard.desktop; // 56 + 2 = 58
    }
    measureMiniLiveOutright(event, markets, showOddButtons) {
        return showOddButtons
            ? this.constants.heights.MiniLiveOutright.desktop
                + this.constants.heights.ButtonInMiniLiveOutright.desktop
                + this.constants.offsets.ButtonContainerMiniLiveOutright.desktop
                + this.constants.offsets.DefaultMiniCard.desktop // 36 + 42 + 8 + 2 = 88
            : this.constants.heights.MiniLiveOutright.desktop
                + this.constants.offsets.DefaultMiniCard.desktop; // 36 + 2 = 38
    }
    measureLiveOutright() {
        return !this.deviceDetect.isMobile
            ? this.constants.heights.LiveOutright.desktop
                + this.constants.offsets.LiveOutright.desktop // 54 + 2 = 56
            : this.constants.heights.LiveOutright.mobile
                + this.constants.offsets.LiveOutright.mobile; // 72 + 2 = 74
    }
    measurePreliveOutright(event, markets) {
        const selectionsCount = markets[0].selections.length;
        const selectionsToShow = Math.min(selectionsCount, this.outrightSelectionsCount);
        const showViewAll = selectionsCount > this.outrightSelectionsCount;
        const selectionHeight = this.setPreliveOutrightHeight(selectionsToShow, this.deviceDetect.isDesktop);
        const subheadingHeight = this.shouldShowOutrightSubheading
            ? this.getSubheadingHeight()
            : 0;
        const viewAllBtnHeight = showViewAll
            ? this.setViewAllPreliveOutrightHeight(this.deviceDetect.isDesktop)
            : 0;
        return selectionHeight + subheadingHeight + viewAllBtnHeight;
    }
    getOffsetValue(event) {
        if (this[`getOffsetValue${event.componentType}`]) {
            return this[`getOffsetValue${event.componentType}`]();
        }
        return this.deviceDetect.isDesktop
            ? this.constants.offsets.DefaultCard.desktop // 2
            : this.constants.offsets.DefaultCard.mobile; // 2
    }
    getOffsetValueAggregateCard() {
        return this.constants.offsets.AggregateCard.desktop; // 4
    }
    getOffsetValuePreliveOutright() {
        return 0;
    }
    setMiniAmericanCardHeightDesktop(selectionsCount) {
        // 2*28 + 2*2 + 4 = 64 for 2 button rows, 3*28 + 3*2 + 4 = 94 for 3 button rows
        return selectionsCount * this.constants.heights.ButtonInMiniAmericanCard.desktop
            + selectionsCount * this.constants.offsets.ButtonInMiniAmericanCard.desktop
            + this.constants.offsets.ButtonContainerMiniCard.desktop;
    }
    setAmericanCardHeightDesktop(selectionsCount) {
        const buttonsHeight = selectionsCount > 2
            ? 3 * this.constants.heights.ButtonInAmericanCard.desktop
            : 2 * this.constants.heights.ButtonInAmericanCard.desktop;
        const leagueHeight = this.showLeagueInEventCard
            ? this.constants.heights.ButtonInAmericanCard.desktop
            : 0;
        // 88 for 3 button rows, 62 for 2 button rows
        const height = this.constants.heights.AmericanCard.desktop
            + buttonsHeight
            - this.constants.offsets.ButtonInAmericanCard.desktop
            + this.constants.offsets.DefaultCard.desktop;
        return selectionsCount > 2
            ? height
            : height + leagueHeight;
    }
    setAmericanCardHeightMobile(selectionsCount) {
        const buttonsHeight = selectionsCount > 2
            ? 3 * this.constants.heights.ButtonInAmericanCard.mobile
            : 2 * this.constants.heights.ButtonInAmericanCard.mobile;
        // 64 + 2 + 44*3 = 198 for 3 button rows, 64 + 2 + 44*2 = 154 for 2 button rows
        return this.constants.heights.AmericanCard.mobile
            + this.constants.offsets.DefaultCard.mobile
            + buttonsHeight;
    }
    setPreliveOutrightHeight(selectionsCount, isDesktop) {
        return isDesktop
            ? this.setPreliveOutrightHeightDesktop(selectionsCount)
            : this.setPreliveOutrightHeightMobile(selectionsCount);
    }
    setViewAllPreliveOutrightHeight(isDesktop) {
        return isDesktop
            ? this.constants.heights.ViewAllButtonContainer.desktop // 55
            : this.constants.heights.ViewAllButtonContainer.mobile; // 70
    }
    setPreliveOutrightHeightDesktop(selectionsCount) {
        return Math.ceil(selectionsCount / 2) * this.constants.heights.PreliveOutright.desktop // 49
            + 2 * this.constants.offsets.PreliveOutrightContainer.desktop; // 2 * 2 = 4
    }
    setPreliveOutrightHeightMobile(selectionsCount) {
        return selectionsCount * this.constants.heights.PreliveOutright.mobile // 48
            + 2 * this.constants.offsets.PreliveOutrightContainer.mobile; // 2 * 2 = 4
    }
}
//# sourceMappingURL=ComponentManager.js.map